import React from 'react'
import {Link} from "react-router-dom";
import {addressCharLimits} from "../common/handleAddress";
import ButtonLoading from "./ButtonLoading";
import ModalAsync from "./ui/ModalAsync";
import { Tooltip, Alert } from 'antd';
import { InfoCircleOutlined, ThunderboltOutlined } from '@ant-design/icons';

const ConsolidationModal = ({
  consolidationMode,
  conDiscard,
  consolidation,
  conPadding,
  consolidationPackages,
  conRequest,
  conCost,
  conOptionsCost,
  message,
  loading,

  autoRepackLoading,
  manualRepackLoading,

  setState,
  remOption,
  addOption,

  handleSubmitConsolidationRequest,
  handleSubmitManualRepackRequest,
  handleSubmitAutoRepackRequest,
  enableManualRepack,
  cancelConsolidation
}) => {

  const content = (
    <div style={{padding: '0 10px'}}>
      <div className="modal-cons-packages">
        {consolidation.map(packageId => {
          let padSelected = conPadding.includes(packageId)
          let isConsolidation = consolidationPackages.map(p=>p.packageId).includes(packageId)
          return (
            <div className="modal-cons-pkg" key={'con'+packageId}>
              <div className="modal-cons-pkg-label">{isConsolidation ? 'Consolidation' : 'Package'} <Link to={`/package?pkg=${packageId.toString()}`}> #{packageId.toString().padStart(6, '0')} </Link> </div>
              {isConsolidation ?
                <div className="modal-cons-pkg-opts modal-cons-pkg-noopt">No options available for prior combinations</div>
                :
                <div className="modal-cons-pkg-opts">
                  <div className={"modal-cons-pkg-opt"+(padSelected ? ' modal-cons-pkg-opt-active' : '')} onClick={padSelected ? ()=>{remOption(packageId, 'pad')} : ()=>{addOption(packageId, 'pad')}}><i className="material-icons">{padSelected ? 'check_box' : 'check_box_outline_blank'}</i> Extra Padding</div>
                </div>
              }
            </div>
          )
        })}
      </div>
      <div className="modal-cons-notes">
        <div className="modal-cons-notes-label">Comments</div>
        <textarea className="form-control modal-cons-notes-actual" onChange={(e) => setState({conRequest: e.target.value})} value={conRequest} maxLength={addressCharLimits.notes} />
      </div>
      <div className="modal-cons-charges">
        <div className="modal-cons-charge-label">Combination Fee</div>
        <div className="modal-cons-charge-amt">${conCost.toFixed(2)}</div>
      </div>
      {!!conOptionsCost &&
        <div className="modal-cons-charges">
          <div className="modal-cons-charge-label">Options</div>
          <div className="modal-cons-charge-amt">${conOptionsCost.toFixed(2)}</div>
        </div>
      }
      {!!message && !loading && <div className="payment-message">{message}</div>}
    </div>
  )

  const footer = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 5
      }}>
        {
          enableManualRepack ? (
            <Tooltip title="Packages are manually combined by transferring their contents into a new box, a process that can take over 24 hours. Consolidation may be canceled if the combined size or weight exceeds limits.">
              <button className="btn btn-primary mr-3" disabled={!!manualRepackLoading} onClick={handleSubmitManualRepackRequest}>{manualRepackLoading ? <ButtonLoading/> : <> <InfoCircleOutlined className='mr-2'/> Combine Packages </>}</button>
            </Tooltip>
            ) : null
        }
        <Tooltip title="Using smart automation, we select the best box for your packages, enabling immediate shipping. Your packages are consolidated into a larger box without unpacking, ensuring a quick and efficient process.">
          <button className="btn btn-green" disabled={!!autoRepackLoading} onClick={handleSubmitAutoRepackRequest}>{autoRepackLoading ? <ButtonLoading/> : <> <ThunderboltOutlined className='mr-2'/> Combine & Ship Now </> } </button>
        </Tooltip>
      </div>
      <div style={{ margin: 4 }}> <a rel="noreferrer noopener" target='_blank' href='https://intercom.help/reship/en/articles/9912439-reship-s-new-consolidation-changes-boosting-efficiency-and-enhancing-customer-experience'> Learn more about our new consolidation processes </a> </div>
    </div>
  )

  return (
    <>
      {consolidationMode===2 &&
        <ModalAsync
          title="Ship Packages Together"
          visible={consolidationMode===2}
          setVisible={cancelConsolidation}
          children={content}
          footer={footer}
        />
      }
    </>
  )
}

export default ConsolidationModal